import { ElementRef } from '@angular/core';
import { AuthService } from '../../core/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { UserType } from '../../../models/user';
import 'rxjs/add/observable/throw';
import { TranslateService } from '@ngx-translate/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { PlaceholderVisibilityService } from '../../services/placeholder-visibility/placeholder-visibility.service';
import { CommonConstant } from '../../app.constants';
import { UserService } from '../../services/user.service';
import { EventTrackerService, Page, UserActionType, ActivePages } from '../../services/event-tracker/event-tracker.service';
import { AppSettings } from '../../utils/app-settings';
import { WebUtils } from '../../utils/web.utils';
export var ReturnUrlRoute;
(function (ReturnUrlRoute) {
    ReturnUrlRoute["DISCOVER"] = "discover";
    ReturnUrlRoute["ADMIN"] = "framed/admin";
})(ReturnUrlRoute || (ReturnUrlRoute = {}));
var LoginComponent = /** @class */ (function () {
    function LoginComponent(auth, route, router, translate, placeholderService, userService, eventTracker) {
        this.auth = auth;
        this.route = route;
        this.router = router;
        this.translate = translate;
        this.placeholderService = placeholderService;
        this.userService = userService;
        this.eventTracker = eventTracker;
        this.fallbackUtm = {
            utm_source: 'login',
            utm_medium: 'organic',
            utm_campaign: 'organic'
        };
        // this flag is used to know when we should send the login action event to Segment. Prevent duplicate event
        this.canTrackLoginAction = false;
    }
    LoginComponent.prototype.ngOnInit = function () {
        var _this = this;
        WebUtils.loadHubspotChatWidget();
        this.user = new FormGroup({
            username: new FormControl(null, [
                Validators.required,
                Validators.email
            ]),
            password: new FormControl(null, [
                Validators.required
            ])
        });
        var returnUrl = ReturnUrlRoute.DISCOVER;
        var targetUrl = this.route.snapshot.queryParams['target_url'];
        if (targetUrl) {
            var decodedUrl = decodeURIComponent(targetUrl);
            // avoid circular navigation caused by '/login' router
            // redirect by url /login again won't trigger guard
            if (decodedUrl !== '/login' && decodedUrl !== 'undefined') {
                returnUrl = decodedUrl;
            }
        }
        this.returnUrl = returnUrl;
        this.errorMessage = '';
        this.user.valueChanges.subscribe(function (res) {
            _this.errorMessage = null;
        });
    };
    LoginComponent.prototype.ngOnDestroy = function () {
        WebUtils.removeHubspotChatWidget();
    };
    LoginComponent.prototype.forgotPassword = function () {
        this.auth.updateResetPassEmail(this.user.controls.username.value);
        return this.router.navigate(['/reset-password']);
    };
    LoginComponent.prototype.onSubmit = function (_a) {
        var _this = this;
        var value = _a.value, valid = _a.valid;
        if (valid) {
            this.placeholderService.show(CommonConstant.LOGIN_PLACEHOLDER);
            this.auth.login(value.username, value.password, function (data) {
                _this.canTrackLoginAction = true;
                _this.auth.getUserData(function (user) {
                    _this.eventTracker.hasIdentifiedObserver.subscribe(function (res) {
                        if (res && _this.canTrackLoginAction) {
                            _this.eventTracker.trackUserAction(UserActionType.LOGIN, Page.LOGIN, undefined, undefined, undefined, {
                                type: ActivePages.LOGIN,
                            });
                            _this.canTrackLoginAction = false;
                        }
                    });
                    if (_this.auth.getUser().type === UserType.ANALYST) {
                        _this.returnUrl = ReturnUrlRoute.ADMIN;
                    }
                    if (!_this.userService.getCompanyId()) {
                        _this.userService.loadAccountListByUser(_this.auth.getUser(), function () {
                            _this.router.navigateByUrl(_this.returnUrl);
                        });
                    }
                    else {
                        _this.router.navigateByUrl(_this.returnUrl);
                    }
                }, function (err) {
                    _this.errorMessage = _this.translate.instant('LOGIN.server_error');
                    _this.auth.logout();
                });
                _this.placeholderService.hide(CommonConstant.LOGIN_PLACEHOLDER);
            }, function (error) {
                if (error.error && error.error.data === 'invalid_credential') {
                    _this.errorMessage = _this.translate.instant('LOGIN.email_not_verified');
                }
                else if (error.error && error.error.data === 'sso_user_not_allowed') {
                    _this.errorMessage = _this.translate.instant('LOGIN.sso_user', { mmiLoginLink: AppSettings.mmiLoginLink() });
                }
                else if (error.status === 400) {
                    _this.errorMessage = _this.translate.instant('LOGIN.wrong_username_password');
                }
                else {
                    _this.errorMessage = _this.translate.instant('LOGIN.server_error');
                }
                _this.placeholderService.hide(CommonConstant.LOGIN_PLACEHOLDER);
            });
            return;
        }
        var form = this.user;
        if (!form.controls.username.valid) {
            this.showErrorMessageOnInput(this._userNameInput, 'LOGIN.invalid_email');
            return;
        }
        if (!form.controls.password.valid) {
            this.showErrorMessageOnInput(this._passwordInput, 'LOGIN.password_required');
            return;
        }
    };
    LoginComponent.prototype.showErrorMessageOnInput = function (inputElementRef, messageKey) {
        var inputElement = inputElementRef.nativeElement;
        if (!inputElement) {
            return;
        }
        var message = this.translate.instant(messageKey);
        inputElement.focus();
        inputElement.setCustomValidity(message);
        inputElement.reportValidity();
    };
    Object.defineProperty(LoginComponent.prototype, "signUpLink", {
        get: function () {
            var utm_source = this.getUtmData('utm_source');
            var utm_campaign = this.getUtmData('utm_campaign');
            var utm_medium = this.getUtmData('utm_medium');
            return AppSettings.signUpLink() + "?utm_source=" + utm_source + "&utm_campaign=" + utm_campaign + "&utm_medium=" + utm_medium;
        },
        enumerable: true,
        configurable: true
    });
    LoginComponent.prototype.getUtmData = function (utmKey) {
        try {
            return localStorage.getItem(utmKey) || this.fallbackUtm[utmKey];
        }
        catch (error) {
            return this.fallbackUtm[utmKey];
        }
    };
    return LoginComponent;
}());
export { LoginComponent };



// WEBPACK FOOTER //
// ./src/app/auth/login/login.component.ts.pre-build-optimizer.js